import { DomainType } from '@/constants'
import { CurrencyType } from '@/constants/currency'
import { getDynamicDomainBy } from '@/lib/utils'

const isDynamicDomain = process.env.NEXT_PUBLIC_IS_DYNAMIC_DOMAIN === 'true'
const isDevelopment = process.env.NEXT_PUBLIC_NODE_ENV === 'development'

const assetUrl = getDynamicDomainBy({
  type: DomainType.IMAGES,
  isDynamicDomain,
  isDevelopment,
})

const domain = getDynamicDomainBy({ type: DomainType.RAW, isDynamicDomain })
const apiUrl = getDynamicDomainBy({ type: DomainType.API, isDynamicDomain })

// console.log('🚀 ~ apiUrl:', apiUrl)
export const siteConfig = {
  appName: 'MFANS',
  appVersion: `v${process.env.NEXT_PUBLIC_APP_VERSION}` || '-',
  isDynamicDomain,
  isDevelopment,
  domain,
  apiUrl,
  sseUrl: getDynamicDomainBy({ type: DomainType.SSE, isDynamicDomain }),
  assetUrl,
  gtmId: process.env.NEXT_PUBLIC_GTM_ID,
  tokenKey: process.env.NEXT_PUBLIC_API_TOKEN_KEY,
  isDebugging: false,
  validation: {
    email: {
      maxLength: 72,
    },
    password: {
      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/,
      min: 8,
      max: 20,
    },
    code: {
      pattern: /^\d{6}$/,
    },
    videoPrice: {
      min: 3.9,
    },
  },
  domainMap: {
    internet: 'https://mfans.live/zh-TW',
    china: 'https://mshow.co/zh-CN',
  },
  showCTA: process.env.NEXT_PUBLIC_SHOW_CTA?.toLocaleLowerCase() === 'true',
  currency:
    (process.env.NEXT_PUBLIC_CURRENCY as CurrencyType) || CurrencyType.NTD,
  placeholder: {
    videoPrice: 5,
    exchangeRate: parseFloat(process.env.NEXT_PUBLIC_EXCHANGE_RATE || '31.5'),
    avatar: `/placeholder/avatar.jpg`,
    banner: `https://fakeimg.pl/1200x900/?text=Banner`,
    image: `${assetUrl}/placeholder/empty.jpg`,
    video: `${assetUrl}/placeholder/empty.jpg`,
  },
  blackList: {
    categoryIds: [4, 5],
  },
  externalLink: {
    contract:
      'https://docs.google.com/document/d/1Fud3_qKPniUg3JsCQ1i9N0wUOUnAsSVz/edit?usp=sharing&ouid=106802810797801357099&rtpof=true&sd=true',
  },
  shouldShowAuthBottomBar: true,
  test: {
    streaming: {
      example:
        'https://devstreaming-cdn.apple.com/videos/streaming/examples/img_bipbop_adv_example_fmp4/master.m3u8',
      '1680x750':
        'https://demo.unified-streaming.com/k8s/features/stable/video/tears-of-steel/tears-of-steel.mp4/.m3u8',
      '1920x1080':
        'https://res.cloudinary.com/dougsillars/video/upload/c_limit,w_2560,h_1440,vc_h264:high:4.0,br_16m/v1518476665/bbb_38s_s0avek.m3u8',
      '1280x720': 'http://dripls.hulu.com/playlist.m3u8?p=wt_4000k&cdn=b',
      md: 'https://mfans-dev-api.qjyhqjdp.com/api/m3u8?key=d1lhYi9OTzVzQ0d5LzB2OWY2ZERzeHFPQmp4RWJSekdJTC9uNGJvNTc4SWM0OXFTT3JJeVU2ODk4YnZSWmhqc052aG1UMXRKRXdJTVRsY1oxV3QxeXVXK1BnSEtTQkdwczErck5sdmxHS0JJYmJTLzN1eTk2ZmxoN2dTeWlXSlBjK3JXeUtGYnZ2dGhLWitYYklxZENyR01SVTRkOE5JbVV1NUdVeTYveWtEUGZLaFBVYVlIRmVZZisvQ0wvS2pwZlRLV0o5cVZBZThMUFJEN2xMZzBYZTN5YnRuNW1mM1RrWDVobWNma0RTND0',
    },
  },
  sexualIds: [1, 2, 3, 4, 5, 6],
  sexualPreferenceCategoryIds: [1, 2, 3, 4, 5, 6],
  sexualMaps: {
    BG: 1,
    BB: 2,
    GG: 3,
    FTM: 6,
  },
  homePage: {
    event: {
      show: true,
      categoryIds: [17, 18], // 多人 3P
    },
    star: {
      show: true,
      channelIds: {
        BG: [198, 117],
        BB: [94, 102],
      },
      videoIds: {
        BG: [
          1134, 1129, 1131, 1119, 1105, 1000, 709, 1118, 1106, 708, 707, 1074,
          1050, 1046, 297, 296,
        ],
        BB: [
          1132, 1108, 1146, 1145, 1091, 1062, 1144, 1143, 1052, 1041, 1020,
          1082, 1081, 1069, 1002, 1064,
        ],
      },
    },
    featured: {
      show: false,
      channelIds: [17, 32, 47, 124],
    },
  },
  payment: {
    blacklist: ['wechat'],
  },
  prefix: {
    watermark: `${domain}/`,
  },
  pagination: {
    pageSize: 16,
    biggerPageSize: 40,
  },
  metadata: {
    title: `友善亞洲成人內容創作者平台 | MFANS`,
    description: `華語第一成人影視集團麻豆傳媒旗下品牌，致力於給成人創作者及觀眾最流暢的體驗。在平台舒適度之上，完整實現了觀影者及表演者雙贏的全新視界！`,
    keywords: [
      '麻豆',
      '成人影片',
      '成人影音平台',
      '成人串流',
      '獨立創作者',
      '高畫質成人影片',
      '情色影片',
      '免費成人影片',
      '成人網站',
      '無碼影片',
      '素人成人影片',
      'OnlyFans 替代方案',
      '友善創作者',
      '獨立創作者成人內容',
      '付費成人影片',
      '成人影片訂閱制',
      '成人影片會員專區',
      '自製成人影片',
      '成人內容變現',
      '私密成人影片',
      '成人短片',
      '專屬成人內容',
      '成人直播平台',
      '無廣告成人影片',
      '高畫質成人影片',
    ],
    url: `https://${domain}`,
    image: `${assetUrl}/logo.png`,
  },
  activityKey: 'ACTIVITY_VIEWED',
  over18Key: 'OVER_18_CONFIRMED',
}
